"use client"
import {
  Select
} from "./chunk-RFLHYWNR.mjs";

// src/components/autocomplete.ts
import { mergeMultiStyle } from "@yamada-ui/core";
var Autocomplete = mergeMultiStyle(Select)();

export {
  Autocomplete
};
//# sourceMappingURL=chunk-UQ6J2DQU.mjs.map